import _ from 'lodash'
import { Space } from 'antd'
import { CaretRightOutlined, CaretDownOutlined } from '@ant-design/icons'

import Table from 'components/Table'

import Styled from './styled'

export default function TableCorrective({
  loading = false,
  columns = [],
  correctiveColumn = [],
  subColumn = [],
  dataSource = [],
  scroll = {},
}) {
  return (
    <Styled className="table-organization-component">
      <Table
        className="task_name"
        loading={loading}
        columns={_.map(correctiveColumn, (column) => {
          return {
            ...column,
            key: `report_task_${column.key}`,
          }
        })}
        dataSource={dataSource}
        pagination={false}
        scroll={scroll}
        expandable={{
          expandedRowRender: (record) => (
            <Space direction="vertical" size={0} style={{ width: '100%' }}>
              <Table
                className="report_task"
                loading={loading}
                columns={_.map(subColumn, (column) => {
                  return {
                    ...column,
                    key: `report_task_${column.key}`,
                  }
                })}
                dataSource={record.child_task}
                pagination={false}
              />
            </Space>
          ),
          expandIcon: ({ expanded, onExpand, record }) =>
            expanded ? (
              <CaretDownOutlined onClick={(e) => onExpand(record, e)} />
            ) : (
              <CaretRightOutlined onClick={(e) => onExpand(record, e)} />
            ),
        }}
      />
    </Styled>
  )
}
